// @ts-strict-ignore
import { BillingAddress } from 'api/types/shared.types';
import { BackgroundTask, waitTaskCompleted } from 'utils/asyncBackendTask';
import { postJson } from 'utils/http';

export type UTMParams = {
  utmSource?: string;
  utmMedium?: string;
  utmCampaign?: string;
  utmTerm?: string;
  utmContent?: string;
};
export type CreditCard = {
  stripeTokenId: string;
  methodId: string;
};
export type Donation = BillingAddress &
  UTMParams & {
    sfCampaignId?: string;
    amount: string;
    otherAmount: string;
    firstName: string;
    gift: boolean;
    lastName: string;
    email: string;
    phone: string;
    sendEmails: true;
    note: string;
  };
export type DonationPayload = Donation & CreditCard;

type DonationResult = {
  success: boolean;
  invoiceIds?: Array<string>;
  errorHuman?: string;
  error?: {
    msg: string;
    stripeCode: string;
  };
};

const createDonation = (donation, token) =>
  postJson(`/data/website/donate`, { ...donation, token }).then(
    ({ task }) => task
  );

const handleStripeBackgroundTask = (task: BackgroundTask<DonationResult>) =>
  waitTaskCompleted(task);

export const makeDonation = (values: DonationPayload) => {
  const { stripeTokenId, methodId, ...donation } = values;
  return createDonation(donation, stripeTokenId)
    .then((task) => handleStripeBackgroundTask(task))
    .then((result) => result);
};
